/**
 * Generated by orval v7.10.0 🍺
 * Do not edit manually.
 * Risk Modelling Platform API
 * The API for the risk modelling platform
 * OpenAPI spec version: 1.0
 */

/**
 * Stable application-specific error codes. The FE keys its error-message map off these values.

Error codes:

- `PROJECT_LOCKED` — generic umbrella; the project cannot be modified because it is archived or completed. The specific cause is in the more specific code.
- `PROJECT_ARCHIVED` — the project has been archived.
- `PROJECT_COMPLETED` — the project has been marked complete.
- `RUN_IN_PROGRESS` — at least one run is `In progress` or `Importing`. The project cannot be completed while runs are still active.
- `INVALID_PROJECT_TYPE` — the endpoint is only valid for BFRMP projects.

 */
export type ErrorCode = (typeof ErrorCode)[keyof typeof ErrorCode];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ErrorCode = {
  PROJECT_LOCKED: "PROJECT_LOCKED",
  PROJECT_ARCHIVED: "PROJECT_ARCHIVED",
  PROJECT_COMPLETED: "PROJECT_COMPLETED",
  RUN_IN_PROGRESS: "RUN_IN_PROGRESS",
  INVALID_PROJECT_TYPE: "INVALID_PROJECT_TYPE",
} as const;
